const en = {
  states: [
    { code: 'AK', name: 'Alaska' },
    { code: 'AL', name: 'Alabama' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'AS', name: 'American Samoa' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'DE', name: 'Delaware' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'GU', name: 'Guam' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'IA', name: 'Iowa' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MD', name: 'Maryland' },
    { code: 'ME', name: 'Maine' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MT', name: 'Montana' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NY', name: 'New York' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VA', name: 'Virginia' },
    { code: 'VI', name: 'Virgin Islands' },
    { code: 'VT', name: 'Vermont' },
    { code: 'WA', name: 'Washington' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WY', name: 'Wyoming' }
  ],
  stateName: [
    'Alaska',
    'Alabama',
    'Arkansas',
    'American Samoa',
    'Arizona',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Iowa',
    'Idaho',
    'Illinois',
    'Indiana',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Massachusetts',
    'Maryland',
    'Maine',
    'Michigan',
    'Minnesota',
    'Missouri',
    'Mississippi',
    'Montana',
    'North Carolina',
    'North Dakota',
    'Nebraska',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'Nevada',
    'New York',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Virginia',
    'Virgin Islands',
    'Vermont',
    'Washington',
    'Wisconsin',
    'West Virginia',
    'Wyoming'
  ],
  stateCode: [
    'AK',
    'AL',
    'AR',
    'AS',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DC',
    'DE',
    'FL',
    'GA',
    'GU',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VI',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY'
  ],
  gender: ['Female', 'Male', 'Prefer Not to Answer'],
  maritalStatus: [
    'Divorced',
    'Married',
    'Registered Partnership',
    'Separated',
    'Single',
    'Widowed'
  ],
  emergencyRelationshipValue: [
    'An Ex–spouse',
    'Brother',
    'Child',
    'Doctor',
    'Employer',
    'Father',
    'Grandparent',
    'Mother',
    'Neighbor',
    'Relative',
    'Spouse',
    'Friend',
    'Sister',
    'Guardian',
    'Significant Other'
  ],
  availability: ['All Day', 'Select Available Hours', 'Not Available'],

  gendersLookup: [
    {
      genderValue: 'M',
      genderDescription: 'Male'
    },
    {
      genderValue: 'F',
      genderDescription: 'Female'
    },
    {
      genderValue: 'X',
      genderDescription: 'Prefer Not to Say'
    }
  ],
  maritalStatusesLookup: [
    {
      maritalStatusValue: 'M',
      maritalStatusDescription: 'Married'
    },
    {
      maritalStatusValue: 'S',
      maritalStatusDescription: 'Single'
    }
  ],
  statesLookup: [
    {
      stateValue: 'AL',
      stateDescription: 'Alabama'
    },
    {
      stateValue: 'AK',
      stateDescription: 'Alaska'
    },
    {
      stateValue: 'AZ',
      stateDescription: 'Arizona'
    },
    {
      stateValue: 'AR',
      stateDescription: 'Arkansas'
    },
    {
      stateValue: 'CA',
      stateDescription: 'California'
    },
    {
      stateValue: 'CO',
      stateDescription: 'Colorado'
    },
    {
      stateValue: 'CT',
      stateDescription: 'Connecticut'
    },
    {
      stateValue: 'DE',
      stateDescription: 'Delaware'
    },
    {
      stateValue: 'FL',
      stateDescription: 'Florida'
    },
    {
      stateValue: 'GA',
      stateDescription: 'Georgia'
    },
    {
      stateValue: 'HI',
      stateDescription: 'Hawaii'
    },
    {
      stateValue: 'ID',
      stateDescription: 'Idaho'
    },
    {
      stateValue: 'IL',
      stateDescription: 'Illinois'
    },
    {
      stateValue: 'IN',
      stateDescription: 'Indiana'
    },
    {
      stateValue: 'IA',
      stateDescription: 'Iowa'
    },
    {
      stateValue: 'KS',
      stateDescription: 'Kansas'
    },
    {
      stateValue: 'KY',
      stateDescription: 'Kentucky'
    },
    {
      stateValue: 'LA',
      stateDescription: 'Louisiana'
    },
    {
      stateValue: 'ME',
      stateDescription: 'Maine'
    },
    {
      stateValue: 'MD',
      stateDescription: 'Maryland'
    },
    {
      stateValue: 'MA',
      stateDescription: 'Massachusetts'
    },
    {
      stateValue: 'MI',
      stateDescription: 'Michigan'
    },
    {
      stateValue: 'MN',
      stateDescription: 'Minnesota'
    },
    {
      stateValue: 'MS',
      stateDescription: 'Mississippi'
    },
    {
      stateValue: 'MO',
      stateDescription: 'Missouri'
    },
    {
      stateValue: 'MT',
      stateDescription: 'Montana'
    },
    {
      stateValue: 'NE',
      stateDescription: 'Nebraska'
    },
    {
      stateValue: 'NV',
      stateDescription: 'Nevada'
    },
    {
      stateValue: 'NH',
      stateDescription: 'New Hampshire'
    },
    {
      stateValue: 'NJ',
      stateDescription: 'New Jersey'
    },
    {
      stateValue: 'NM',
      stateDescription: 'New Mexico'
    },
    {
      stateValue: 'NY',
      stateDescription: 'New York'
    },
    {
      stateValue: 'NC',
      stateDescription: 'North Carolina'
    },
    {
      stateValue: 'ND',
      stateDescription: 'North Dakota'
    },
    {
      stateValue: 'OH',
      stateDescription: 'Ohio'
    },
    {
      stateValue: 'OK',
      stateDescription: 'Oklahoma'
    },
    {
      stateValue: 'OR',
      stateDescription: 'Oregon'
    },
    {
      stateValue: 'PA',
      stateDescription: 'Pennsylvania'
    },
    {
      stateValue: 'RI',
      stateDescription: 'Rhode Island'
    },
    {
      stateValue: 'SC',
      stateDescription: 'South Carolina'
    },
    {
      stateValue: 'SD',
      stateDescription: 'South Dakota'
    },
    {
      stateValue: 'TN',
      stateDescription: 'Tennessee'
    },
    {
      stateValue: 'TX',
      stateDescription: 'Texas'
    },
    {
      stateValue: 'UT',
      stateDescription: 'Utah'
    },
    {
      stateValue: 'VT',
      stateDescription: 'Vermont'
    },
    {
      stateValue: 'VA',
      stateDescription: 'Virginia'
    },
    {
      stateValue: 'WA',
      stateDescription: 'Washington'
    },
    {
      stateValue: 'WV',
      stateDescription: 'West Virginia'
    },
    {
      stateValue: 'WI',
      stateDescription: 'Wisconsin'
    },
    {
      stateValue: 'WY',
      stateDescription: 'Wyoming'
    }
  ],
  relationshipsLookup: [
    {
      relationshipValue: 'EX',
      relationshipDescription: 'An Ex–spouse'
    },
    {
      relationshipValue: 'B',
      relationshipDescription: 'Brother'
    },
    {
      relationshipValue: 'C',
      relationshipDescription: 'Child'
    },
    {
      relationshipValue: 'DR',
      relationshipDescription: 'Doctor'
    },
    {
      relationshipValue: 'E',
      relationshipDescription: 'Employer'
    },
    {
      relationshipValue: 'F',
      relationshipDescription: 'Father'
    },
    {
      relationshipValue: 'GP',
      relationshipDescription: 'Grandparent'
    },
    {
      relationshipValue: 'M',
      relationshipDescription: 'Mother'
    },
    {
      relationshipValue: 'N',
      relationshipDescription: 'Neighbor'
    },
    {
      relationshipValue: 'R',
      relationshipDescription: 'Relative'
    },
    {
      relationshipValue: 'S',
      relationshipDescription: 'Spouse'
    },
    {
      relationshipValue: 'F',
      relationshipDescription: 'Friend'
    },
    {
      relationshipValue: 'S',
      relationshipDescription: 'Sister'
    },
    {
      relationshipValue: 'GA',
      relationshipDescription: 'Guardian'
    },
    {
      relationshipValue: 'SO',
      relationshipDescription: 'Significant Other'
    },
    {
      relationshipValue: 'O',
      relationshipDescription: 'Other'
    }
  ],
  schedules: [
    {
      scheduleValue: 'A',
      scheduleDescription: 'All Day'
    },
    {
      scheduleValue: 'S',
      scheduleDescription: 'Select Available Hours'
    },
    {
      scheduleValue: 'N',
      scheduleDescription: 'Not Available'
    }
  ]
}

export { en }
